import React, {useState} from 'react';
import './style.css';
import {Card, Col, Modal, Row} from 'antd';
import SectionLayout from '../Layout/sectionLayout';
import ChapterEventCard from './EventCard2.0';
import {useDispatch} from 'react-redux';
import CommonTitleWithFilters from '../CommonTitleWithFilters';
import {useNavigate} from 'react-router-dom';
import useLocalization from '../../../Localization';

const Event2Listing = ({
  countLoadMoreData,
  chaptersList,
  eventTypeList,
  handleEventTypeFilter,
  handleChapterFilter,
  filteredEvents,
  usedForChapPage,
  totalEventCount,
  handleLoadMore,
  selectedChapterValue,
  selectedEventTypeValue,
  selectedDateValue,
  selectedYearValue,
  isChapSelect,
  dateToggle,
  dateOrderHandler,
  eventTypeBool = true,
  hideEventType = false,
  title = '',
  isShowFilter = true,
}) => {
  const {ApplicationString} = useLocalization();
  const Navigate = useNavigate();
  const [isRegistrationModalClosed, setIsRegistrationModalClosed] =
    useState(false);
  const [clickedEventID, setClickedEventID] = useState(null);

  // useEffect(() => {
  //   dispatch(
  //     getAllUserEvents(
  //       selectedChapterValue,
  //       selectedEventTypeValue,
  //       selectedDateValue,
  //     ),
  //   );
  // }, []);

  const registrationClosedModalOkHandler = () => {
    Navigate(`/eventDetails/${clickedEventID}`);
    setIsRegistrationModalClosed(false);
  };

  const registrationClosedModalCancelHandler = () => {
    setIsRegistrationModalClosed(false);
  };

  const content = (
    <div
      className={`event2-listing-container ${
        usedForChapPage && 'event2-listing-container-margin-for-chapPage'
      } `}>
      <Modal
        open={isRegistrationModalClosed}
        centered
        title={ApplicationString['eventListing.regClosed.title']}
        onOk={registrationClosedModalOkHandler}
        onCancel={registrationClosedModalCancelHandler}>
        <p>
          {ApplicationString['eventListing.regClosed.title']}
          <a
            href='mailto:info@pbss.com'
            target='_blank'
            rel='noopener noreferrer'>
            {ApplicationString['eventListing.regClosed.email']}
          </a>{' '}
          {ApplicationString['eventListing.regClosed.moreInfo']}
        </p>
      </Modal>
      <Row gutter={[16, 30]} className='pbssMainContainerRowEventListing'>
        <Col span={24}>
          <Row
            className={`${
              !usedForChapPage && 'upcoming-event-card-mobile-row'
            }`}>
            <CommonTitleWithFilters
              title={title}
              handleChapterFilter={handleChapterFilter}
              handleEventTypeFilter={handleEventTypeFilter}
              newChaptersList={chaptersList}
              eventTypeList={eventTypeList}
              eventTypeSelect={eventTypeBool}
              chapterSelect={isChapSelect ? false : true}
              dateSelect={true}
              usedForChapPage={usedForChapPage}
              selectedEventTypeValue={selectedEventTypeValue}
              selectedChapterValue={selectedChapterValue}
              selectedYearValue={selectedYearValue}
              dateToggle={dateToggle}
              dateOrderHandler={dateOrderHandler}
              isShowFilter={isShowFilter}
            />
          </Row>
        </Col>

        <Col
          span={24}
          className={`${
            !usedForChapPage && 'upcoming-event-card-mobile-background-column'
          }`}>
          <Row
            className={`${
              !usedForChapPage && 'upcoming-event-card-mobile-row'
            } upcoming-event-card-mobile-row-2`}>
            <div className='events-new-listing-cards'>
              {filteredEvents?.length > 0 ? (
                filteredEvents?.map((event, index) => {
                  return (
                    <ChapterEventCard
                      setIsRegistrationModalClosed={
                        setIsRegistrationModalClosed
                      }
                      status={event?.status}
                      usedForChapPage={usedForChapPage}
                      isExpand={true}
                      key={event?.key}
                      id={event?.key}
                      sponsorshipAvailable={event?.sponsorshipAvailable}
                      eventName={event?.eventName}
                      eventDetails={event?.eventDetails}
                      date={event?.date}
                      dateObj={event?.dateObject}
                      speakers={event?.speakers}
                      registerText={
                        Number(event?.status) !== 2
                          ? ApplicationString['eventListing.regOpen.title']
                          : ApplicationString['eventListing.regClosed.title']
                      }
                      price={event?.price}
                      location={event?.location}
                      moreDetails={false}
                      descriptionLabel={
                        ApplicationString['eventListing.speaker']
                      }
                      setClickedEventID={setClickedEventID}
                      eventType={event?.eventType}
                      chapter={event?.eventChapter}
                      hideEventType={hideEventType}
                    />
                  );
                })
              ) : (
                <div>
                  <Row>
                    <Col span={24}>
                      <Card>
                        <div className='not-found-event-heading'>
                          {ApplicationString['eventListing.comingSoon']}
                        </div>
                      </Card>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </Row>
        </Col>
        {/* {totalEventCount > filteredEvents?.length && (
          <Col span={24}>
            <div className='view-more-container'>
              <Button
                id='home-view-more-events-button'
                className='view-more-button'
                onClick={handleLoadMore}>
                <span className='view-more-text'>View More Events</span>
                <DownArrowSvg />
              </Button>
            </div>
          </Col>
        )} */}
      </Row>
    </div>
  );

  return (
    <React.Fragment>
      {usedForChapPage ? (
        content
      ) : (
        <SectionLayout extendClass='event-card-mobile'>{content}</SectionLayout>
      )}
      {/* <RecentOpeningsJobs
          title={'Recent Job Openings'}
          buttonName={'View Details'}
          data={allApprovedJobsData}
          flex={true}
          handleNext={handleNext}
          handlePrev={handlePrev}
        />
        <RecentOpeningsAds
          title={'Ads'}
          buttonName={'Visit Now'}
          data={allApprovedAdsData}
          flex={true}
          handleNextAds={handleNextAds}
          handlePrevAds={handlePrevAds}
        /> */}
    </React.Fragment>
  );
};
export default Event2Listing;
